module.exports = __webpack_public_path__ + "img/14.4259e02b.jpg";